import type { TutorBillingChangeComparisonRow, TutorBillingRow } from '../model/interfaces'

import { buildTutorBillingFields, TUTOR_BILLING_EMPTY_VALUE } from './tutor-billing-fields'

export const buildTutorBillingChangeComparison = (
  row: TutorBillingRow,
  getPaymentServiceLabel: (value: string | null) => string,
): TutorBillingChangeComparisonRow[] => {
  const changeRequest = row.change_request
  if (!changeRequest) return []

  const currentFields = buildTutorBillingFields(row, getPaymentServiceLabel)
  const nextFields = buildTutorBillingFields({ ...row, payment: changeRequest.new }, getPaymentServiceLabel)
  const nextValues = new Map(nextFields.map(field => [field.key, field.value]))

  return currentFields
    .filter(field => field.key !== 'id')
    .map((field) => {
      const next = nextValues.get(field.key) ?? TUTOR_BILLING_EMPTY_VALUE

      return {
        key: field.key,
        label: field.label,
        current: field.value,
        next,
        changed: field.value !== next,
      }
    })
}
